export const register = (editor: any) => {
  editor.addButton('customFieldsCombo', {
    type: 'listbox',
    text: 'Personalize',
    icon: false,
    onselect() {
      editor.insertContent(this.value());
      this.value('');
    },
    values: JSON.parse(JSON.stringify(window.Kajabi?.themeBuilder?.fields || [])),
  });
};
